/* =====================================================================
   ewh-motion.js  ·  El Workshop
   Entradas al bajar por la pagina + barra de progreso de lectura.

   SEGURIDAD (leccion del "contenido fantasma" de julio):
   - La clase html.ewh-motion, de la que cuelga TODO el CSS que oculta,
     solo se anade desde aqui. Sin JS no se oculta nada, nunca.
   - Solo se marca lo que esta POR DEBAJO del pliegue en ese momento, asi
     que lo visible al cargar jamas parpadea.
   - Si el navegador aun no ha medido la ventana (prerender, pestana sin
     pintar), no se toca nada: sin alto de viewport no hay "pliegue" que
     valga y todo se quedaria escondido.
   - Ademas del IntersectionObserver hay una red de seguridad por scroll:
     si el observador fallara, cualquier elemento que entre en pantalla
     se muestra igual.

   COMO DECIDE QUE ANIMAR: no depende de nombres de clase (cada seccion
   de la tienda usa los suyos).
   1) Si el bloque es muy alto -Profesionales u Hoteles son UNA seccion
      de doce pantallas- se trocea por filas y cada fila va por su cuenta.
   2) Dentro busca las reticulas reales (grid o flex con varias piezas):
      - dos columnas una al lado de otra -> se cruzan (una sube, otra baja)
      - tres o mas piezas -> entran en cascada
      - la pieza que es sobre todo una foto -> se descubre como un telon
      - el titular -> sale de detras de una linea
   3) Si no encuentra nada repetido, empuja el bloque entero.

   Los barridos se repiten (carga, 300 ms, 1 s, 2,5 s): al principio las
   fotos aun no han dado altura a la pagina y media tienda cae "por
   encima del pliegue". Una seccion solo se da por resuelta cuando de
   verdad se ha marcado algo en ella.
   ===================================================================== */
(function () {
  'use strict';

  /* --- 1. Salvaguardas de entrada ----------------------------------- */
  if (!('IntersectionObserver' in window)) return;
  var mqReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mqReduce && mqReduce.matches) return;

  var doc = document;
  var root = doc.documentElement;

  /* Solo paginas de contenido. Fuera: ficha de producto, coleccion,
     carrito, cuenta, buscador... donde hay filtros, cargas parciales y
     deslizadores que no conviene tocar. */
  var ALLOWED = ['index', 'page', 'article', 'blog', 'list-collections'];

  /* Contextos que NO se animan: deslizadores y marquesinas (llevan
     transform propio) y la cabecera. Las animaciones de entrada del
     tema (js-animation-*) SI las asumimos: el CSS las anula en el
     elemento marcado y las sustituye por esta entrada. */
  var SKIP_CLOSEST = '.swiper, .swiper-wrapper, .swiper-slide, swiper-container,' +
    '[class*="marquee"], [class*="slider"], header, .header, back-to-top,' +
    '[data-ewh-reveal]';

  var STAGGER = 90;      /* ms entre piezas */
  var MAX_STEPS = 4;     /* tope de la cascada: nunca pasa de 360 ms */
  var MAX_DEPTH = 7;     /* niveles a explorar dentro de un bloque */
  var MAX_VISIT = 220;   /* tope de nodos visitados por bloque */
  var MAX_GROUPS = 2;    /* reticulas por bloque */
  var MAX_MARKS = 14;    /* piezas por bloque */
  var SPLIT_SCREENS = 2.2; /* a partir de este alto, el bloque se trocea */
  var MIN_ROW = 120;     /* alto minimo de una fila para trocear */
  var MIN_VIEWPORT = 300;

  var pending = [];
  var observer = null;

  /* --- 2. Utilidades ------------------------------------------------ */

  function templateAllowed() {
    var list = doc.body.classList;
    for (var i = 0; i < ALLOWED.length; i++) {
      if (list.contains('template--' + ALLOWED[i])) return true;
    }
    return false;
  }

  function belowFold(el) {
    var r = el.getBoundingClientRect();
    if (r.height === 0 && r.width === 0) return false;
    return r.top > window.innerHeight * 0.85;
  }

  /* No tocamos nada que ya venga transformado, pegado (sticky/fixed) o
     que contenga algo pegado: mover su contenedor lo romperia. */
  function unsafe(el) {
    if (el.closest(SKIP_CLOSEST)) return true;
    if (el.className && String(el.className).indexOf('sticky') > -1) return true;
    if (el.querySelector && el.querySelector('[class*="sticky"]')) return true;
    var cs = window.getComputedStyle(el);
    if (!cs) return true;
    if (cs.transform && cs.transform !== 'none') return true;
    if (cs.position === 'sticky' || cs.position === 'fixed') return true;
    if (cs.display === 'none') return true;
    return false;
  }

  function show(el) {
    el.setAttribute('data-ewh-in', '');
    if (observer) observer.unobserve(el);
  }

  function mark(el, kind, step) {
    if (!el || el.hasAttribute('data-ewh-reveal')) return false;
    if (!belowFold(el) || unsafe(el)) return false;
    var delay = Math.min(step || 0, MAX_STEPS) * STAGGER;
    if (delay) el.style.setProperty('--ewh-delay', delay + 'ms');
    el.setAttribute('data-ewh-reveal', kind);
    if (kind === 'head') {
      maskHeading(el);
    } else if (kind !== 'media') {
      /* Titular dentro de la pieza: el bloque empuja y, un pelin
         despues, el texto sale de detras de su linea. Dos capas. */
      var inner = el.querySelector('h1, h2, h3');
      if (inner && maskHeading(inner)) inner.style.setProperty('--ewh-delay', (delay + 120) + 'ms');
    }
    pending.push(el);
    observer.observe(el);
    return true;
  }

  /* El titular se recorta y su contenido se envuelve en un span que
     entra desde abajo: el texto parece salir de detras de una linea. */
  function maskHeading(el) {
    if (!el.firstChild || el.querySelector('.ewh-mask-in')) return false;
    var span = doc.createElement('span');
    span.className = 'ewh-mask-in';
    while (el.firstChild) span.appendChild(el.firstChild);
    el.appendChild(span);
    el.setAttribute('data-ewh-mask', '');
    return true;
  }

  /* Hijos que pintan algo (fuera style, script, link...) */
  function kidsOf(el) {
    var out = [];
    var c = el.children;
    for (var i = 0; i < c.length; i++) {
      var t = c[i].tagName;
      if (t === 'STYLE' || t === 'SCRIPT' || t === 'LINK' || t === 'TEMPLATE' || t === 'NOSCRIPT') continue;
      out.push(c[i]);
    }
    return out;
  }

  function isHeading(el) {
    var t = el.tagName;
    return t === 'H1' || t === 'H2' || t === 'H3';
  }

  /* Pieza que es sobre todo una foto: se lleva el telon. Las tarjetas de
     producto quedan fuera, que tienen su propio cambio de imagen al
     pasar el raton. */
  function isMedia(el) {
    if (el.querySelector('.hover-img, product-card, .product-card')) return false;
    var m = el.querySelector('img, picture, video');
    if (!m) return false;
    var a = el.getBoundingClientRect();
    var b = m.getBoundingClientRect();
    if (!a.width || !a.height) return false;
    return (b.width * b.height) >= (a.width * a.height) * 0.5;
  }

  /* Dos piezas una al lado de la otra (foto + texto, lo tipico). */
  function sideBySide(kids) {
    if (kids.length !== 2) return false;
    var a = kids[0].getBoundingClientRect();
    var b = kids[1].getBoundingClientRect();
    if (!a.width || !b.width) return false;
    if (Math.abs(a.top - b.top) > 60) return false;
    return (a.right <= b.left + 8) || (b.right <= a.left + 8);
  }

  /* Una reticula de verdad: grid o flex, entre 2 y 12 piezas, con altura
     suficiente para no confundirla con una fila de botones. */
  function isGrid(el, kids) {
    if (kids.length < 2 || kids.length > 12) return false;
    var cs = window.getComputedStyle(el);
    var d = cs.display || '';
    if (d.indexOf('grid') === -1 && d.indexOf('flex') === -1) return false;
    if (el.getBoundingClientRect().height < 60) return false;
    if (kids[0].getBoundingClientRect().height < 32) return false;
    return true;
  }

  function findGroups(scope, allowRoot) {
    var found = [];
    var queue = [[scope, 0]];
    var visited = 0;
    while (queue.length && visited < MAX_VISIT) {
      var item = queue.shift();
      var el = item[0];
      var depth = item[1];
      visited++;
      if (depth > MAX_DEPTH) continue;
      var kids = kidsOf(el);
      if (!kids.length) continue;
      if ((depth > 0 || allowRoot) && isGrid(el, kids)) found.push({ box: el, kids: kids });
      for (var i = 0; i < kids.length; i++) queue.push([kids[i], depth + 1]);
    }
    /* Gana la reticula con mas piezas; luego descartamos las que se
       solapen con ella (una dentro de otra animaria dos veces). */
    found.sort(function (a, b) { return b.kids.length - a.kids.length; });
    var picked = [];
    for (var f = 0; f < found.length && picked.length < MAX_GROUPS; f++) {
      var clash = false;
      for (var p = 0; p < picked.length; p++) {
        if (picked[p].box.contains(found[f].box) || found[f].box.contains(picked[p].box)) { clash = true; break; }
      }
      if (!clash) picked.push(found[f]);
    }
    /* Y se ordenan como estan en la pagina, para que la cascada baje. */
    picked.sort(function (a, b) {
      return (a.box.compareDocumentPosition(b.box) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });
    return picked;
  }

  function insideGroups(el, groups) {
    for (var g = 0; g < groups.length; g++) {
      var kids = groups[g].kids;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] === el || kids[i].contains(el)) return true;
      }
    }
    return false;
  }

  /* Contenedor real del contenido: si el bloque es una sucesion de
     envoltorios de hijo unico, bajamos hasta el ultimo. Asi se mueve el
     contenido y NO el fondo de color o la foto a sangre. */
  function contentBox(scope) {
    var el = scope;
    for (var i = 0; i < 4; i++) {
      var kids = kidsOf(el);
      if (kids.length !== 1) break;
      el = kids[0];
    }
    return el;
  }

  /* Devuelve cuantas piezas ha marcado en este bloque. */
  function markScope(scope, depth) {
    var box = contentBox(scope);

    /* 1) Bloque muy alto: se trocea por filas. */
    if (depth < 2 && scope.getBoundingClientRect().height > window.innerHeight * SPLIT_SCREENS) {
      var rows = [];
      var candidates = kidsOf(box);
      for (var c = 0; c < candidates.length; c++) {
        if (candidates[c].getBoundingClientRect().height >= MIN_ROW) rows.push(candidates[c]);
      }
      if (rows.length >= 3) {
        var total = 0;
        for (var r = 0; r < rows.length; r++) total += markScope(rows[r], depth + 1);
        if (total) return total;
      }
    }

    /* 2) Reticulas dentro del bloque. En una fila troceada el propio
       bloque puede SER la reticula, por eso allowRoot en depth > 0. */
    var groups = findGroups(scope, depth > 0);
    var marks = 0;
    var headStep = 0;

    if (groups.length) {
      var head = scope.querySelector('h1, h2, h3');
      if (head && !insideGroups(head, groups) && mark(head, 'head', 0)) { headStep = 1; marks++; }
      for (var g = 0; g < groups.length; g++) {
        var kids = groups[g].kids;
        /* Cada reticula arranca su propia cascada: si no, las de mas
           abajo entrarian ya con el retardo tope y se notaria el lag. */
        var step = g === 0 ? headStep : 0;

        /* Dos columnas: entran a la vez y en sentidos opuestos. */
        if (sideBySide(kids)) {
          if (mark(kids[0], 'pair-a', step)) marks++;
          if (mark(kids[1], 'pair-b', step)) marks++;
          continue;
        }

        for (var i = 0; i < kids.length && marks < MAX_MARKS; i++) {
          var kid = kids[i];
          var kind = isHeading(kid) ? 'head' : (isMedia(kid) ? 'media' : 'tile');
          if (mark(kid, kind, step)) { step++; marks++; }
        }
      }
    }

    /* 3) Nada repetido dentro: entra el bloque de una pieza. */
    if (!marks && mark(box, 'block', 0)) marks++;

    return marks;
  }

  function processSection(section) {
    if (section.hasAttribute('data-ewh-done')) return;
    /* Si no se marco nada, la seccion queda abierta a un barrido
       posterior: puede que la pagina aun no tuviera su altura real. */
    if (markScope(section, 0)) section.setAttribute('data-ewh-done', '');
  }

  function scan() {
    var sections = doc.querySelectorAll('#MainContent .shopify-section:not([data-ewh-done])');
    for (var i = 0; i < sections.length; i++) processSection(sections[i]);
  }

  /* --- 3. Red de seguridad ------------------------------------------ */

  var ticking = false;
  function guard() {
    ticking = false;
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      if (el.hasAttribute('data-ewh-in') || !el.isConnected) { pending.splice(i, 1); continue; }
      if (el.getBoundingClientRect().top < window.innerHeight) {
        show(el);
        pending.splice(i, 1);
      }
    }
  }
  function queueGuard() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(guard);
  }

  function sweep() {
    scan();
    queueGuard();
  }

  function revealAll() {
    while (pending.length) show(pending.pop());
  }

  /* --- 4. Barra de progreso de lectura ------------------------------ */

  function progressBar() {
    var bar = doc.createElement('div');
    bar.className = 'ewh-progress';
    bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);

    var raf = false;
    function paint() {
      raf = false;
      var max = doc.documentElement.scrollHeight - window.innerHeight;
      var ratio = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, ratio)) + ')';
    }
    function onScroll() {
      if (raf) return;
      raf = true;
      window.requestAnimationFrame(paint);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  /* --- 5. Arranque --------------------------------------------------- */

  function init() {
    root.classList.add('ewh-motion');

    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) show(entries[i].target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    sweep();

    window.addEventListener('scroll', queueGuard, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    window.addEventListener('beforeprint', revealAll);
    window.addEventListener('load', sweep);
    window.addEventListener('pageshow', queueGuard);
    doc.addEventListener('visibilitychange', queueGuard);
    doc.addEventListener('shopify:section:load', sweep);

    window.setTimeout(sweep, 300);
    window.setTimeout(sweep, 1000);
    window.setTimeout(sweep, 2500);
  }

  var boots = 0;
  function boot() {
    if (window.innerHeight >= MIN_VIEWPORT) { init(); return; }
    /* Ventana sin medir todavia. Reintentamos un rato y, si nunca llega
       a medirse, no se anima nada: preferimos quieto a escondido. */
    if (boots++ > 6) return;
    window.setTimeout(boot, 400);
  }

  function start() {
    progressBar();
    if (!templateAllowed()) return;
    boot();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
